import { Table } from "antd";
import styled from "styled-components";

export const GridContainer = styled.div`
  grid-area: grd;
`

export const StyledDataGrid = styled(Table)`
  //font-family: "FuturaPT";

  & * {
    border-color: #ddd !important;
  }

  .ant-table-thead {
    .ant-table-cell {
      background: #fff;
    }
  }

  .ant-table-cell {
    background: #fff;

    @media (max-width: 768px) {
      padding: 5px !important;
    }
  }

  .ant-table-tbody {
    .ant-table-row {
      &:hover .ant-table-cell {
        background: #fff;
      }

      .ant-table-cell {
        padding: 10px;
    
        &.logo {
          overflow: hidden;
        }
      }

      &.vip .ant-table-cell {
        background: rgb(232, 243, 253);
      }
    }
  }
  
  
`
